export enum EducationLevelEnum {
  IncompleteHighSchool = 1,
  HighSchool = 2,
  Bachelor = 3,
  Master = 4,
  Doctorate = 5,
  College = 6,
  Other = 7,
}
